import React, { act, ChangeEvent, useEffect, useState } from "react";
import "./../components/categories/categories.scss";
import Appservice from "../services/appservice";
import { getCategoriesByQuestioanrieId } from "../helpers/ServiceSections";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../commonfields/inputs/TextInput";
import plusIcon from "../images/plusIcon.svg";
import closeIcon from "../images/closeIcon.svg";
import tagcheckIcon from "../images/tagCheckIcon.svg";
import tagcloseIcon from "../images/tagClose.svg";
import { RoutesEnum } from "../tsmodels/RoutesModel";
import { ReactComponent as BackIcon } from "../images/back-icon.svg";
import { ReactComponent as SearchIcon } from "../images/search-icon.svg";
import { Button, Input } from "reactstrap";
import { catchError } from "../utils/Utils";
import { AxiosError } from "axios";
import SpinnerModel from "../commonfields/inputs/SpinnerModel";
import questionsData from "../data/ApplicationData";

interface Question {
  questionId: number;
  questionText: string;
}

interface Subcategory {
  subcategoryName: string;
  questions: Question[];
}

interface ParentCategory {
  parentCategoryName: string;
  subcategories: Subcategory[];
}

const Categories: React.FC = (props: any) => {
  const [activeCategory, setActiveCategory] = useState<string>("");
  const [subActiveCategory, setSubActiveCategory] = useState<string>("All");
  const [questionnaireData, setQuestionnaireData] = useState<
    ParentCategory[] | []
  >([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [allData, setAllData] = useState<any>([]);
  const [subTabs, setSubTabs] = useState<any>([]);
  const [inputValue, setInputValue] = useState("");
  const [questionSearch, setQuestionSearch] = useState("");
  const [tags, setTags] = useState<string[]>([]);

  const service = new Appservice();
  const navigate = useNavigate();
  const { questionnaireId,questionnaireName} = useParams();

  // funcs-Api call

  const postAddTags = (question: any, index:number, e:any) => {    
    if(e.keyCode!==13){
      return;
    }
    let _tags = getTags(question.questionTags);
    if(e.isDelete){
      _tags = _tags.filter((v:any, index2:any)=>index2!==index)
    } else {
      if(!e?.target?.value?.trim()){
        return;
      }
    _tags[index]= e.target.value;
    }
    _tags = JSON.stringify(_tags);
    question.editableIndex = index;
    service.updateQuestionTags({questionTags:_tags, questionId:question.questionId}).then((res:any)=>{
        
        setQuestionnaireData(questionnaireData.map((q:any)=>{
          if(q.questionId === question.questionId){
            q.questionTags = _tags;
            question.editableIndex = -1;
          }
          return q;
        }))
    }).catch((err:any)=>{

    });
   // setTags([...tags, `Tag${nextTagNumber}`]);
  };
  const handleAddTags = (question: any, e?:any, index:any=-1) => {
    let _tags = question.questionTags?getTags(question.questionTags) : [];
   
    const v= e && e?.target?.value || '';
    if(index===-1){
      if(_tags.length && !_tags[_tags.length-1]){
          return;
      }
       _tags = [..._tags, ''];
    } else {
      _tags[index] = v;
    }
    setQuestionnaireData(questionnaireData.map((q:any)=>{
      if(q.questionId === question.questionId){
        q.questionTags = JSON.stringify(_tags);
        q.editableIndex = index===-1?_tags.length-1:index;
      }
      return q;
    }));
   // setTags([...tags, `Tag${nextTagNumber}`]);
  };

  const getQuestionsList = async() => {
    const payLoad = {
      sections: "getCategoriesByQuestioanrieId",
      screen: "QuestionarieScreen",
      questionarieId: questionnaireId,
      isJsonReturnObject: true,
    };
    setLoader(true);
   await service
      .getQuestionsList(payLoad)
      .then((res) => {       
        const categories = (res?.data||[]);
        setAllData(categories);
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      })

      .finally(() => {
        setLoader(false);
      });
  };

  const updateDescription = (payLoad:any) => {
  //   const payLoad = {
  //  description:"",
  //  questionId: ""

  //   };
    setLoader(true);
    service
      .updateQuestionDescription(payLoad.description,payLoad.questionId)
      .then((res) => {
        // const categories = res.data;
        
        // setAllData(categories);
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      })

      .finally(() => {
        setLoader(false);
      });
  };

  const filterCategories = (parentcatg: any = "", catg: any = "") => {
    if (!parentcatg) {
      return;
    }
    if (!catg) {
      catg = "All";
    }
    setActiveCategory(parentcatg);
    setSubActiveCategory(catg);
    let cateegory: any = allData.find(
      (c: any) => c.parentCategoryName === parentcatg
    );
    let subcategories = cateegory.subcategories || [];
    let questions = [];
    if (catg?.toLowerCase() === "all") {
      subcategories.forEach((subCatg: any) => {
        questions.push(...(subCatg.questions || []));
      });
    } else {
      questions =
        subcategories.find(
          (subCat: any) =>
            subCat.subcategoryName?.toLowerCase() === catg?.toLowerCase()
        )?.questions || [];
    }

    setQuestionnaireData(questions);
    let tabs: any = ["All"];
    subcategories.forEach((subCat: any) => {
      subCat.subcategoryName?.toLowerCase()!=='all' && tabs.push(subCat.subcategoryName);
    });

    setSubTabs(tabs);
  };
  const handleChange = (id:any,description:any) => {
    
    setQuestionnaireData(questionnaireData.map((q:any)=>{
      if(q.questionId===id){
        q.description = description
      }
      return q;
    }));
  }
  const handleFocusOut = (id:any,description:any) => {
    
    updateDescription({
      "description":description,
      "questionId" : id
    })
  };

  const goBack = () => navigate(`/${RoutesEnum.QUESTIONNAIRE}`);
  
  const filterQuestinaryData  = (questions:any) => {    
    if(questionSearch?.trim()){
       return questions.filter((f:any)=>{
           if(f.questionText?.toLowerCase().includes(questionSearch?.toLowerCase())){
              return true;
           }
           return false;
       })
    }
    return questions ;

 }

  const handleQuestionSearch = (e: any) => {
    setQuestionSearch(e?.target?.value);
   // e?.target?.value?.trim() && setQuestionnaireData(questionnaireData.filter((q:any)=>q.questionText?.toLowerCase()?.includes(e?.target?.value?.toLowerCase())));
  };

  // funcs - render
  // useEffect
  useEffect(() => {
    filterCategories(allData[0]?.parentCategoryName);
  }, [allData]);
  useEffect(() => {
    getQuestionsList();
  }, []);

  const getTags = (tags:any)=>{
      if(tags){
        try{
        return JSON.parse(tags);
        } catch(e){
          return []
        }
      }
      return []
  }

  return (
    <>
  
      <div className="subheader-container questionnaire-subheader">
        <div className="subheader-left">
          <div className="subheader-icon" onClick={goBack}>
            <BackIcon />
          </div>
          <div className="subheader-title">{decodeURI(questionnaireName || "")}</div>
        </div>
        <div className="subheader-right">
          <div className="subheader-input-container">
            <TextInput
              className="subheader-input"
              value={questionSearch}
              onChange={handleQuestionSearch}
              placeholder="Search for question"
            />
            <SearchIcon className="search-icon" />
          </div>
        </div>
      </div>
      <div className="questionnaire">
        <div className="sidebar">
          <div className="side-header">CATEGORIES</div>
          <ul>
            {(allData||[])?.map((category: any, index: any) => (
              <li
                key={index}
                onClick={() => filterCategories(category.parentCategoryName)}
                className={`categoryName ${
                  activeCategory === category.parentCategoryName ? "active" : ""
                }`}
              >
                {category.parentCategoryName}
              </li>
            ))}
          </ul>
        </div>
        <div className="question-list">
          <div className="tabs">
            {subTabs.map((tab: any) => (
              <div
                key={tab.id}
                className={`tab ${subActiveCategory === tab ? "active" : ""}`}
                onClick={() => filterCategories(activeCategory, tab)}
              >
                {tab}
              </div>
            ))}
          </div>

          <div className="question-itemList">
            {filterQuestinaryData(questionnaireData)?.map((question: any, subIndex: any) => (
              <div className="question-item">
                <div key={subIndex} className="question">
                  <div className="id-text">
                    <div className="question-id">{question.questionId}</div>
                    <div className="question-text">
                      {question.questionText}
                    </div>
                  </div>
                  
                  <div className="question-tags">
                  <img
                      className="plus-icon"
                      src={plusIcon}
                      alt="plusIcon"
                      onClick={() => handleAddTags(question)}
                    />
                  {getTags(question?.questionTags)?.map((tag:any, index:any) => (
                      
                      (question?.editableIndex!==index)?<span  onClick={(e)=>handleAddTags(question,{target:{value:tag}}, index)} className={`tag ${question?.editableIndex}`} key={tag}>{tag}</span>:
                      <><div className="input-comtainer"><Input className="editableTag" value={tag} onChange={(e) => handleAddTags(question, e, index)} onKeyDown={(e: any) => postAddTags(question, index, e)} /><img onClick={(e: any) => postAddTags(question, index, {target:{value:tag},keyCode:13})} className="save-icon" src={tagcheckIcon} alt="save-icon" /><img className="delete-icon" onClick={(e: any) => {e.stopPropagation();postAddTags(question, index, {target:{value:""},keyCode:13, isDelete:true})}} src={tagcloseIcon} alt="delete-icon" /> </div></>             
                    ))}
                  
                    
                  
                   
                
                  </div>
                </div>
                <div className="question-description">
                  <div className="title">DESCRIPTION</div>
                  <div className="description">
                    {/* <TextInput
                type="text"
                value={question.description}              
                onChange={(e: any) => handleChange(e.target.value)}
              /> */}
                    <Input                                    
                     name="text" 
                     type="textarea" 
                     value={question.description}  
                     onChange={(e: any) => handleChange( question.questionId, e.target.value)}            
                     onBlur={(e: any) => handleFocusOut( question.questionId, e.target.value)}/>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Categories;
